/* import { IProjectMacro1, IProjectMacro1WithInfo } from '../../MacRO1/store/project/projectSlice';
import { IChannelGeometryVerticalDropForm } from '../../Macro2/components/InputForm/ChannelGeometry/IChannelGeometry';
import { IWeirGeometrySlopedWeirForm, IWeirGeometrySteppedWeirForm, IWeirGeometryVerticalDropForm } from '../../Macro2/components/InputForm/WeirGeometry/IWeirGeometry';
import { IWingsGeometrySlopedWeirForm, IWingsGeometrySteppedWeirForm, IWingsGeometryVerticalDropForm } from '../../Macro2/components/InputForm/WingsGeometry/IWingsGeometry'; */
import { EProjectType } from '../../enum/project';
import { IProjectInfoForm } from '../../pages/ProjectInfo/IProjectInfo';
import { getUser } from '../../store';
import { IProjectMacro2, IProjectMacro2WithInfo } from '../../Macro2/store/project/projectslice';
import { IMacro2TemplateRequest, IProjectMacro1Request, IProjectMacro2Request, ITemplateRequest, IMacro2ProjectPutData, IMacro1ProjectPutData } from '../IApiRequest';
import { IDesigner, IProjectBaseResponse, IMacro2ProjectOutputData } from '../IApiResponse';
/* import { serializeTemplateMacro2Request, serializeTemplateRequest } from '../utils'; */
import BeMaccaferriStoreProvider from './BeMaccaferriStoreProvider';

export const getCountryByCoordinatesAsync = async (latitude: number, longitude: number) => BeMaccaferriStoreProvider.getCountryByCoordinates(latitude, longitude);

//PROJECT------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
export const getProjectsByDesignerAsync = async (designer: number, pageNumber: number, pageSize: number) => BeMaccaferriStoreProvider.getProjectsByDesignerAsync(designer, pageNumber, pageSize);

export const getProjectsAsync = async (pageNumber: number, pageSize: number) => BeMaccaferriStoreProvider.getProjectsAsync(pageNumber, pageSize);

export const getProjectCountriesAsync = async (countryName?: string) => BeMaccaferriStoreProvider.getProjectCountriesAsync(countryName);
export const getProjectSiteEnvLevelAsync = async (lang?: string) => BeMaccaferriStoreProvider.getProjectSiteEnvLevelsAsync(lang);

export const projectAvailableByAuthorAsync = async (id: number, author: string) => BeMaccaferriStoreProvider.projectAvailableByAuthorAsync(id, author);

export const getProjectBaseAsync = async (id: number) => BeMaccaferriStoreProvider.getProjectBaseAsync(id);

export const getMacro1ProjectByIdAsync = async (id: number) => BeMaccaferriStoreProvider.getMacro1ProjectByIdAsync(id);

//export const getMacro2ProjectByIdAsync = async (id: number) => BeMaccaferriStoreProvider.getMacro2ProjectByIdAsync(id);

export const getMacro1ProjectAsync = async (id: string) => BeMaccaferriStoreProvider.getMacro1ProjectAsync(id);

export const putMacro1ProjectAsync = async (projectData: IMacro1ProjectPutData) => BeMaccaferriStoreProvider.putMacro1ProjectAsync(projectData);

export const getMacro2ProjectAsync = async (id: string) => BeMaccaferriStoreProvider.getMacro2ProjectAsync(id);

export const putMacro2ProjectAsync = async (projectData: IMacro2ProjectPutData) => BeMaccaferriStoreProvider.putMacro2ProjectAsync(projectData);

export const deleteProjectByIdAsync = async (id: number) => BeMaccaferriStoreProvider.deleteProjectByIdAsync(id);

export const addProjectAsync = async (projectInfo: IProjectInfoForm) => {
    return BeMaccaferriStoreProvider.addProjectAsync(projectInfo);
};

export const putProjectAsync = async (projectInfo: IProjectInfoForm) => {
    return BeMaccaferriStoreProvider.putProjectAsync(projectInfo);
};

const handleDesignerAsync = async (projectInfo: IProjectInfoForm) => {
    try {
        return await getDesignerByNameAsync(projectInfo?.designerFirmName!);
    } catch (error: any) {
        if (error.response.status == 404) {
            let designerPayload: IDesigner = {
                name: projectInfo?.designerFirmName!,
                country: projectInfo?.designerFirmCountry!,
                city: projectInfo?.designerFirmCity!,
            };
            await addDesignerAsync(designerPayload);
            return await getDesignerByNameAsync(projectInfo?.designerFirmName!);
        }
    }
};

export const updateProjectFromFileAsync = BeMaccaferriStoreProvider.updateProjectFromFileAsync;

/* export const updateProjectAsync = async (project: IProjectMacro2, projectInfo: IProjectInfoForm) => {
    let designer = await handleDesignerAsync(projectInfo);
    const user = getUser();
    let payload: IProjectMacro2Request = {
        projectType: '2',
        projectName: projectInfo?.name!,
        notes: projectInfo?.notes,
        owner: projectInfo?.owner!,
        lastUpdateDate: new Date(),
        number: projectInfo?.number,
        latitude: projectInfo?.latitude!,
        longitude: projectInfo?.longitude!,
        author: user.data!.email!,
        unit: projectInfo?.unit!,
        type: projectInfo?.type!,
        RockSlope: project.rockSlope!,
        designerId: designer!.data.id!,
        projectId: projectInfo.id,
    };

    return BeMaccaferriStoreProvider.updateProjectAsync(payload);
}; */

//COMPANY------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
export const getDesignerByIdAsync = async (id: number) => BeMaccaferriStoreProvider.getDesignerByIdAsync(id);

export const getDesignerByNameAsync = async (designerName: string) => BeMaccaferriStoreProvider.getDesignerByNameAsync(designerName);

export const addDesignerAsync = async (designer: IDesigner) => BeMaccaferriStoreProvider.addDesignerAsync(designer);

//blob
export const getAllDocumentsAsync = async () => BeMaccaferriStoreProvider.getAllDocumentsAsync();

export const uploadDocumentAsync = async (payload: FormData) => BeMaccaferriStoreProvider.uploadDocumentAsync(payload);

export const deleteDocumentAsync = async (name: string) => BeMaccaferriStoreProvider.deleteDocumentAsync(name);


